import { render, staticRenderFns } from "./BattlesGameElement.vue?vue&type=template&id=074a60ad&scoped=true"
import script from "./BattlesGameElement.vue?vue&type=script&lang=js"
export * from "./BattlesGameElement.vue?vue&type=script&lang=js"
import style0 from "./BattlesGameElement.vue?vue&type=style&index=0&id=074a60ad&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "074a60ad",
  null
  
)

export default component.exports